import { Form } from "antd";
import Password from "antd/es/input/Password";
import React from "react";

const SubjectPassword: React.FC = () => {
  return (
    <Form.Item
      name={["managingUser", "systemUser", "password"]}
      label="Password"
      rules={[
        {
          required: false,
          message: "Please enter the password",
        },
      ]}
    >
      <Password />
    </Form.Item>
  );
};

export default SubjectPassword;
